export default Vue => {
  Vue.prototype.$global = new Vue({
    data() {
      return {
        workItem: null
      }
    }
  })
}
